export const initialState = {
  allPermissions: null,
  permissionsLoaded: false,
  allRoles: null,
  rolesLoaded: false
}

export const Actions = {
  SET_PERMISSIONS: 'SET_PERMISSIONS',
  SET_ROLES: 'SET_ROLES',
  UPDATE_ROLE: 'UPDATE_ROLE',
  DELETE_ROLE: 'DELETE_ROLE'
}

export const RolesPermissionsReducer = (state, action) => {
  const { type } = action

  switch (type) {
    case Actions.SET_PERMISSIONS:
      return handleSetPermissions(state, action)
    case Actions.SET_ROLES:
      return handleSetRoles(state, action)
    case Actions.UPDATE_ROLE:
      return handleUpdateRole(state, action)
    case Actions.DELETE_ROLE:
      return handleDeleteRole(state, action)

    default:
      throw new Error(`Unknown dms reducer type: ${type}`)
  }
}

// gets all permissions from the system, then sets loaded to true
const handleSetPermissions = (state, action) => {
  const { permissions } = action
  const newObj = {}
  Object.entries(permissions).forEach(([_key, val]) => {
    newObj[val.id] = val
  })

  return { ...state, allPermissions: newObj, permissionsLoaded: true }
}

const handleSetRoles = (state, action) => {
  const { roles } = action
  const newObj = {}
  Object.entries(roles).forEach(([_key, val]) => {
    newObj[val.id] = val
  })

  return { ...state, allRoles: newObj, rolesLoaded: true }
}

const handleUpdateRole = (state, action) => {
  const { editRole } = action

  return {
    ...state,
    allRoles: {
      ...state.allRoles,
      [editRole.id]: editRole
    }
  }
}

const handleDeleteRole = (state, action) => {
  const { removeId } = action

  const roles = { ...state.allRoles }
  delete roles[removeId]

  return {
    ...state,
    allRoles: {
      ...roles
    }
  }
}
